import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { AllServices } from "@/components/site/SeoLinks";
import { HowItWorks } from "@/components/site/HowItWorks";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Faq } from "@/components/site/Faq";
import { Quote } from "@/components/site/Quote";
import { Seo } from "@/components/site/Seo";

export default function Home() {
  return (
    <>
      <Seo
        title="Junk Removal Greenville SC | Cazares Junk Removal"
        description="Cazares Junk Removal offers fast, friendly, affordable junk removal in Greenville, SC and the Upstate. Free onsite quotes, upfront pricing, same-day pickup."
        path="/"
      />
      <Hero />
      <Marquee />
      <Services />
      <AllServices />
      <HowItWorks />
      <BeforeAfter />
      <ServiceArea />
      <Faq />
      <Quote />
    </>
  );
}
